import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search:''
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    searchFilter: (state, action) => {
      state.search = action.payload
    }
  }
});

export const { searchFilter } = searchSlice.actions;
export default searchSlice.reducer;

